import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KeycloakConfiguration } from '@models/online-reputation.models';

@Injectable({
  providedIn: 'root'
})
export class InitService {

    private readonly httpClient = inject(HttpClient);

    initConfig(): Observable<KeycloakConfiguration> {
        return this.httpClient.get<KeycloakConfiguration>(`api/init/config`);
    }
}
